module.exports = __webpack_public_path__ + "img/speaker-5.1b1c6cd0.jpg";